const colors = [
  '#9c2dd2',
  '#009688',
  '#e65100',
  '#FF708B',
  '#FFBA6A',
  '#E7E7ED',
  '#f44336',
  '#8bc34a',
  '#b2ebf2',
  '#3e2723',
  '#33691e',
  '#827717',
  '#bbdefb',
  '#D4a3ee',
  '#1b5e20',
  '#dcedc8',
  '#0d47a1',
  '#000000',
  '#7986cb',
  '#fff176',
  '#e57373',
  '#ffccbc',
  '#1976d2',
  '#fbc02d',
  '#c2185b',
  '#9c27b0',
  '#e91e63',
  '#D9D9D9',
  '#ffcdd2',
  '#81c784',
  '#525252',
  '#03a9f4',
  '#e1bee7',
  '#00bcd4',
  '#9575cd',
  '#0097a7',
  '#311b92',
  '#212121',
  '#b2dfdb',
  '#afb42b',
  '#0288d1',
  '#4a148c',
  '#9e9e9e',
  '#388e3c',
  '#cfd8dc',
  '#aed581',
  '#ba68c8',
  '#263238',
  '#bf360c',
  '#ff5722',
  '#a1887f',
  '#616161',
  '#ffcdd2',
  '#f57f17',
  '#fff9c4',
  '#ff9800',
  '#673ab7',
  '#4fc3f7',
  '#c5cae9',
  '#d32f2f',
  '#f57c00',
  '#f5f5f5',
  '#689f38',
  '#ff6f00',
  '#f06292',
  '#795548',
  '#ffd54f',
  '#607d8b',
  '#ffe0b2',
  '#ffecb3',
  '#b3e5fc',
  '#e57373',
  '#00796b',
  '#01579b',
  '#455a64',
  '#cddc39',
  '#2196f3',
  '#194d33',
  '#f0f4c3',
  '#7b1fa2',
  '#ffa000',
  '#c8e6c9',
  '#ffeb3b',
  '#4db6ac',
  '#ffc107',
  '#303f9f',
  '#f8bbd0',
  '#3f51b5',
  '#dce775',
  '#90a4ae',
  '#d1c4e9',
  '#512da8',
  '#ff8a65',
  '#e64a19',
  '#5d4037',
  '#64b5f6',
  '#006064',
  '#ffb74d',
  '#004d40',
  '#4dd0e1',
  '#d7ccc8',
  '#969696',
  '#1a237e',
  '#4caf50',
  '#880e4f',
  '#e0e0e0',
];

export default colors;
